import { render, staticRenderFns } from "./BetMatchDialog.vue?vue&type=template&id=d135d9e8&scoped=true"
import script from "./BetMatchDialog.vue?vue&type=script&lang=js"
export * from "./BetMatchDialog.vue?vue&type=script&lang=js"
import style0 from "./BetMatchDialog.vue?vue&type=style&index=0&id=d135d9e8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d135d9e8",
  null
  
)

export default component.exports